import { render, staticRenderFns } from "./RightDetailPanel.vue?vue&type=template&id=173572f7&scoped=true"
import script from "./RightDetailPanel.vue?vue&type=script&lang=js"
export * from "./RightDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./RightDetailPanel.vue?vue&type=style&index=0&id=173572f7&prod&lang=scss&scoped=true"
import style1 from "./RightDetailPanel.vue?vue&type=style&index=1&id=173572f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173572f7",
  null
  
)

export default component.exports